import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormAttachment from '../../../../library/form/components/FormAttachment';
import FormLink from '../../../../library/form/components/FormLink';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormTitle from '../../../../library/form/components/FormTitle';
import FormStatus from '../../../../library/form/components/FormStatus';
import DocFormReview from "../../../cmn/docReviewStatus/DocFormReview";
import FormWrapper from '../../../../library/form/components/FormWrapper'

import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColTwo, UiCol } from "../../../../library/layout/Index";
import DocAdminInfo from '../../../cmn/DocAdminInfo';

const BudgetHeaderViewer = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null);

    return (
        <>
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span>
                            <FormTitle formObject={formObject} value='' />
                        </span>
                    </UiTitle>

                    <UiAction>
                        <DocAdminInfo formObject={formObject} rowKey="" headerKey="adminInfo"/>
                        <FormButton formObject={formObject} ksc="h" rowKey=""
                            action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                            className="uiActionButton" text={<SarasTrans value="Edit" />}></FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <UiGridColTwo>
                        <UiCol>
                            <ul>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docId" }} value="" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docId" }} className='uiHighlightKey' />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemId" }} value="Item Id" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "itemId" }} className='' />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cat1" }} value="" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "cat1" }} className='' />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cat2" }} value="" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "cat2" }} className='' />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "budgetDate" }} value="Budget Date" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "budgetDate" }} className='' />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "value1" }} value="Ord Quantity" />
                                    </span>
                                    <FormROValue format="" formObject={formObject} rowKey="" action={{ paramName: "value1" }} className='uiHighlightKey' />
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "uom1" }} className='' />

                                    <FormROValue format="" formObject={formObject} rowKey="" action={{ paramName: "value2" }} className='uiHighlightKey' />
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "uom2" }} className='' />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "linkedValue1" }} value="Linked Quantity" />
                                    </span>
                                    <FormROValue format="" formObject={formObject} rowKey="" action={{ paramName: "linkedValue1" }} className='' />
                                </li>
                                <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "currency" }} >
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} value="Currency" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "currency" }} className='' />
                                </FormWrapper>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "status" }} value="Status" />
                                    </span>
                                    <FormStatus formObject={formObject} rowKey="" headerKey="docStatus"/>
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "review" }} value="Review" />
                                    </span>
                                    <DocFormReview formObject={formObject} />
                                </li>
                            </ul>
                        </UiCol>
                        <UiCol>
                            <ul>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cat3" }} value="Plan Group" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "cat3" }} className='' />
                                </li>
                                <li>
                                    <FormAttachment imgHeight="50px" formObject={formObject} rowKey="" action={{ InputType: "i", paramName: "itemImage" }} />
                                    <FormLink formObject={formObject} rowKey="" linkProp={{ target: "_blank" }}
                                        action={{ paramName: "itemName", actionId: "show", actionName: "itemComp" }}
                                    />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cat4" }} value="" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "cat4" }} className='' />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cat5" }} value="" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "cat5" }} className='' />
                                </li>
                               
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "location" }} value="Location" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "location" }} className='' />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile" }} value="Profile" />
                                    </span>
                                    <FormLink formObject={formObject} rowKey="" linkProp={{ target: "_blank" }}
                                        action={{ paramName: "profile", actionId: "show", actionName: "proComp" }}
                                    />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comment" }} value="Comment" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "comment" }} className='' />
                                </li>
                            </ul>
                        </UiCol>
                    </UiGridColTwo>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(BudgetHeaderViewer, "budgetHeader", "budgetHeader");